module.exports = __webpack_public_path__ + "img/Icon-Character-Swarm.ef3a486f.svg";